<template>
  <div>
    <div
      style="padding: 15px 30px"
      class="blue_holder mb-4"
      v-if="resheduleCalender"
    >
      <div>
        You are rescheduling lesson from
        {{
          eachEventInfo.extendedProps.course.schedule_date
            | moment("Do, MMMM  YYYY")
        }}
        {{
          eachEventInfo.extendedProps.course.schedule_from_time.slice(0, -3)
            | OnlytimeFormatLocalization
        }}-{{
          eachEventInfo.extendedProps.course.schedule_to_time.slice(0, -3)
            | OnlytimeFormatLocalization
        }}
      </div>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="p-1">
          <div class="overflow_auto_flatpickr">
            <flat-pickr
              @input="fetchTimeByDate"
              class="w-full mb-2"
              v-model="schedule_start_date"
              :config="config"
            ></flat-pickr>
          </div>
        </vs-col>
        <vs-col
          vs-lg="6"
          vs-sm="12"
          class="px-4 py-1"
          v-if="availabilityTime.length > 0"
        >
          <h5 class="mb-4">Choose your available time slot</h5>
          <div style="border-right: none" class="time_zone_holder">
            <template v-for="(eachtime, index) in availabilityTime">
              <vs-radio
                class="mr-2 mb-2"
                :disabled="eachtime.status == 'Unavailable'"
                :key="index"
                v-model="timeSlot"
                vs-name="timezone"
                :vs-value="eachtime"
              >
                <div class="bg-grey">
                  {{ eachtime.from_time.slice(0, -3) }} -
                  {{ eachtime.to_time.slice(0, -3) }}
                </div>
              </vs-radio>
            </template>
          </div>
          <vs-button type="border" color="danger" class="m-1" @click="closeReshedule">Cancel</vs-button>
          <vs-button @click="confirmReschedule" class="m-1"
            >Confirm Reschedule</vs-button
          >
        </vs-col>
        <vs-col
          vs-lg="6"
          vs-sm="12"
          class="flex flex-col justify-center items-center px-4 py-1"
          v-if="availabilityTime.length == 0"
        >
          <p style="opacity: 0.7">No dates selected yet</p>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
import { fetchResheduleSlot,   confirmRescheduleApi } from '@/api/calenderAction.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  props: {
    resheduleCalender: {
      default: false
    },
    eachEventInfo: {
      default: []
    }
  },
  components: {
    flatPickr
  },
  data () {
    return {
      config: {
        inline: true
      },
      schedule_start_date: null,
      availabilityTime: [],
      customer_id: localStorage.getItem('customer_id')
    }
  },
  methods: {
    closeReshedule () {
      this.resheduleCalender = false
      this.$emit('closeReshedule', true)
    },
    async confirmReschedule () {
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id,
        schedule_id: this.eachEventInfo.extendedProps.course.id,
        changed_from_date: this.schedule_start_date,
        changed_from_time: this.timeSlot.from_time,
        changed_to_time: this.timeSlot.to_time
      }
      await confirmRescheduleApi(this.customer_id, payload)

      this.showSuccessMessage(
        'Success',
        'Course resheduled Successfully',
        'success'
      )

      this.$emit('closeCalendarAttendance', true)
      //this.fetchResheduleLog()
    },
    async fetchTimeByDate () {
      this.fetchTime(this)
    },
    fetchTime: _.debounce(async (vm) => {
      try {
        vm.fetchToChooseTime()
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async fetchToChooseTime () {
      try {
        this.$vs.loading()
        const payload = {
          course_start_date: this.schedule_start_date,
          course_id: this.eachEventInfo.extendedProps.course.course_id,
          start_time: this.eachEventInfo.extendedProps.course.schedule_from_time,
          end_time: this.eachEventInfo.extendedProps.course.schedule_to_time,
          teacher_id: [this.eachEventInfo.extendedProps.userId]
        }
        const { data } = await fetchResheduleSlot(this.customer_id, payload)

        this.availabilityTime = data.data.slots
        this.$vs.loading.close()

      } catch (e) {
        //
        this.$vs.loading.close()

      }
    
    }
  }
}
</script>